import React from 'react';
import { Navigate, useParams } from 'react-router';

interface RedirectProps {
  to: string;
}

const Redirect = ({ to }: RedirectProps) => {
  const params = useParams();

  const newPath = to
    .split('/')
    .map((part) => {
      if (!part.startsWith(':')) return part;
      const paramName = part.substring(1);

      return params[paramName];
    })
    .join('/');

  return <Navigate to={newPath} replace />;
};

export default Redirect;
